/** Attachment kinds Multi-Chat uses for outbound media (aligned with MESSAGE_TYPES). */
export const OUTBOUND_MEDIA_ATTACHMENT_TYPES = [
    "IMAGE",
    "VIDEO",
    "AUDIO",
    "DOCUMENT",
    "STICKER",
];
/** WhatsApp Cloud API outbound limits (Meta Developer Tools MCP, Dec 2025). */
const WHATSAPP_OUTBOUND = [
    {
        attachmentType: "IMAGE",
        maxBytes: 5 * 1024 * 1024,
        allowedMimeTypes: ["image/jpeg", "image/png"],
        captions: true,
        filename: false,
        replies: true,
    },
    {
        attachmentType: "VIDEO",
        maxBytes: 16 * 1024 * 1024,
        allowedMimeTypes: ["video/mp4", "video/3gpp"],
        captions: true,
        filename: false,
        replies: true,
    },
    {
        attachmentType: "AUDIO",
        maxBytes: 16 * 1024 * 1024,
        allowedMimeTypes: [
            "audio/aac",
            "audio/amr",
            "audio/mpeg",
            "audio/mp4",
            "audio/ogg",
            "audio/ogg; codecs=opus",
        ],
        captions: false,
        filename: false,
        replies: true,
    },
    {
        attachmentType: "DOCUMENT",
        maxBytes: 100 * 1024 * 1024,
        allowedMimeTypes: [
            "text/plain",
            "application/pdf",
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "application/vnd.ms-powerpoint",
            "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        ],
        captions: true,
        filename: true,
        replies: true,
    },
    {
        attachmentType: "STICKER",
        maxBytes: 500 * 1024,
        allowedMimeTypes: ["image/webp"],
        captions: false,
        filename: false,
        replies: true,
    },
];
/** Messenger Send API / Saving assets (Meta MCP, Jun 2026). User sticker upload not supported. */
const FACEBOOK_OUTBOUND = [
    {
        attachmentType: "IMAGE",
        maxBytes: 8 * 1024 * 1024,
        allowedMimeTypes: ["image/jpeg", "image/png", "image/gif", "image/webp"],
        captions: false,
        filename: false,
        replies: true,
    },
    {
        attachmentType: "VIDEO",
        maxBytes: 25 * 1024 * 1024,
        allowedMimeTypes: ["video/mp4", "video/quicktime", "video/webm"],
        captions: false,
        filename: false,
        replies: true,
    },
    {
        attachmentType: "AUDIO",
        maxBytes: 25 * 1024 * 1024,
        allowedMimeTypes: ["audio/mpeg", "audio/mp4", "audio/wav", "audio/aac", "audio/ogg"],
        captions: false,
        filename: false,
        replies: true,
    },
    {
        attachmentType: "DOCUMENT",
        maxBytes: 25 * 1024 * 1024,
        allowedMimeTypes: [
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "text/plain",
        ],
        captions: false,
        filename: true,
        replies: true,
    },
];
/**
 * Instagram Login Send API on graph.instagram.com (Meta MCP, Jun 2026).
 * No user sticker; like_heart is out of scope for Order 29 composer uploads.
 */
const INSTAGRAM_OUTBOUND = [
    {
        attachmentType: "IMAGE",
        maxBytes: 8 * 1024 * 1024,
        allowedMimeTypes: ["image/jpeg", "image/png", "image/gif"],
        captions: false,
        filename: false,
        replies: false,
    },
    {
        attachmentType: "VIDEO",
        maxBytes: 25 * 1024 * 1024,
        allowedMimeTypes: ["video/mp4", "video/ogg", "video/quicktime", "video/webm"],
        captions: false,
        filename: false,
        replies: false,
    },
    {
        attachmentType: "AUDIO",
        maxBytes: 25 * 1024 * 1024,
        allowedMimeTypes: ["audio/aac", "audio/mp4", "audio/wav", "audio/m4a"],
        captions: false,
        filename: false,
        replies: false,
    },
    {
        attachmentType: "DOCUMENT",
        maxBytes: 25 * 1024 * 1024,
        allowedMimeTypes: ["application/pdf"],
        captions: false,
        filename: true,
        replies: false,
    },
];
export function getOutboundMediaCapabilities(platform) {
    switch (platform) {
        case "WHATSAPP":
            return { platform, entries: WHATSAPP_OUTBOUND, maxAttachmentsPerSend: 1 };
        case "FACEBOOK":
            return { platform, entries: FACEBOOK_OUTBOUND, maxAttachmentsPerSend: 1 };
        case "INSTAGRAM":
            return { platform, entries: INSTAGRAM_OUTBOUND, maxAttachmentsPerSend: 1 };
        default: {
            const _exhaustive = platform;
            return _exhaustive;
        }
    }
}
export function findOutboundMediaCapability(platform, attachmentType) {
    const normalized = attachmentType.toUpperCase();
    return (getOutboundMediaCapabilities(platform).entries.find((entry) => entry.attachmentType === normalized) ?? null);
}
export function isOutboundMediaMimeAllowed(platform, attachmentType, mimeType) {
    const capability = findOutboundMediaCapability(platform, attachmentType);
    if (!capability) {
        return false;
    }
    const normalized = mimeType.toLowerCase().split(";")[0]?.trim() ?? "";
    return capability.allowedMimeTypes.some((allowed) => allowed.toLowerCase().split(";")[0]?.trim() === normalized);
}
//# sourceMappingURL=outbound-media-capabilities.js.map